<p class="modal-header font-bold">Contact information</p>
<div class="rounded-md border border-grey-lighter w-full">
	<div
		class="flex gap-2 ml-2 items-center my-5 font-bold p-5 cursor-pointer"
		(click)="toggleAddContact()"
		*ngIf="!addContact && !contact"
	>
		<app-icon [icon]="ICON.ADD"></app-icon>
		<p>Add main contact</p>
	</div>
	<div *ngIf="!addContact && contact" class="px-5 pt-2">
		<div class="flex justify-between items-center">
			<div class="flex gap-2 items-center">
				<app-icon [icon]="ICON.ADDRESS_CARD" class="text-green"></app-icon>
				<p class="font-bold">{{ contact.name }}</p>
			</div>
			<app-icon
				[icon]="ICON.EDIT"
				class="cursor-pointer"
				(click)="toggleAddContact()"
			></app-icon>
		</div>
		<p class="text-xs text-grey-light mb-2">{{ contact.title }}</p>
		<div class="text-sm flex flex-col gap-2 mb-4">
			<div class="flex gap-2" *ngIf="contact.phone">
				<app-icon class="text-grey-lighter" [icon]="ICON.PHONE"></app-icon>
				<span class="hover:text-green hover:underline">
					<a
						externalNavInterceptor
						href="tel:{{ contact?.phone }}"
						target="_blank"
						>{{ contact.phone }}</a
					>
				</span>
			</div>
			<div class="flex gap-2" *ngIf="contact.email">
				<app-icon class="text-grey-lighter" [icon]="ICON.EMAIL"></app-icon>
				<span class="hover:text-green hover:underline">
					<a emailLinkInterceptor [mailto]="contact?.email">{{
						contact?.email
					}}</a>
				</span>
			</div>
		</div>
	</div>
	<div *ngIf="addContact" class="px-5">
		<div class="flex justify-between items-center my-2">
			<div class="flex gap-3">
				<app-icon [icon]="ICON.ADDRESS_CARD" class="text-green"></app-icon>
				<p class="font-bold">Add main contact details</p>
			</div>
			<app-icon
				[icon]="ICON.DELETE"
				class="cursor-pointer"
				(click)="deleteContactInfo()"
			></app-icon>
		</div>
		<div class="grid grid-cols-2 gap-2">
			<app-input label="Full name" [(ngModel)]="name"></app-input>
			<app-input label="Title" [(ngModel)]="title"></app-input>
			<app-input label="Phone number" [(ngModel)]="phone"></app-input>
			<app-input label="Email" [(ngModel)]="email"></app-input>
		</div>
	</div>
	<hr class="w-full my-4 text-grey-lighter" />
	<div class="flex gap-2 px-5 mb-2">
		<app-icon class="text-green" [icon]="ICON.BUILDING"></app-icon>
		<p class="font-bold">{{ companyName }}</p>
	</div>
	<div class="text-sm px-5 flex flex-col gap-2 mb-4">
		<div class="flex gap-2">
			<app-icon class="text-grey-lighter" [icon]="ICON.LOCATION"></app-icon>
			<p>{{ companyAddress }}</p>
		</div>
		<div class="flex gap-2">
			<app-icon class="text-grey-lighter" [icon]="ICON.PHONE"></app-icon>
			<p>
				<span
					*ngFor="let phone of companyPhone"
					class="hover:text-green hover:underline"
				>
					<a externalNavInterceptor href="tel:{{ phone }}" target="_blank">{{
						phone
					}}</a
					><span *ngIf="phone !== companyPhone[companyPhone.length - 1]"
						>,
					</span>
				</span>
			</p>

			<p></p>
		</div>
		<div class="flex gap-2">
			<app-icon class="text-grey-lighter" [icon]="ICON.FAX"></app-icon>
			<p>
				<span
					*ngFor="let fax of companyFax"
					class="hover:text-green hover:underline"
				>
					<a externalNavInterceptor href="tel:{{ fax }}" target="_blank">{{
						fax
					}}</a
					><span *ngIf="fax !== companyFax[companyFax.length - 1]">, </span>
				</span>
			</p>

			<p></p>
		</div>
	</div>
</div>
<div class="flex mt-4 justify-between">
	<app-button size="small" btn="secondary" (click)="close()">Close</app-button>
	<app-button
		*ngIf="addContact"
		size="small"
		btn="primary"
		(click)="addContactDetails()"
		>Save</app-button
	>
</div>
